import { TableCell } from "@mui/material";

export const TableBodyCell = ({ children, sx }) => (
  <TableCell sx={{...sx, fontSize: 16, fontWeight: '600', textTransform:"capitalize"}}>
      {children}
  </TableCell>
)